import { useCallback } from 'react';
import useError, { reportError } from 'src/screens/error/useError';

export const useApiErrorHandler = () => {
  const { setError } = useError();

  const handleError = useCallback(
    (error: any) => {
      setError(reportError(error));
    },
    [setError]
  );

  return handleError;
};
